var a = 0;
var b = 0;
var c = 0;
$(".pitch input").keyup(function(){
  	calc();
})

function calc(){
	a = $('.pitch input[name="flat"]').val();
	b = $('.pitch input[name="rsize"]').val();
	c = $('.pitch input[name="rafter"]').val();
	var d = $('.pitch input[name="degree"]').val();
	var e = $('.pitch input[name="percentage"]').val();
  	edge();
  	var deg = Math.asin(a/c)*180/Math.PI;
  	$('.pitch input[name="degree"]').val(deg.toFixed(2));
  	$('.pitch input[name="percentage"]').val( ((a/b)*100).toFixed(2) );
// 	console.log("guyhjgyuh", a,b,c,d,e, deg);
}

function edge(){
  	if(a > 0 && b > 0){
      	c = Math.sqrt(a*a + b*b);
      	$('.pitch input[name="rafter"]').val(c.toFixed(2));
//     	console.log("Calculate C", c);
    }
  	else if(a > 0 && c > 0){
      	b = Math.sqrt(c*c - a*a);
      	$('.pitch input[name="rsize"]').val(b.toFixed(2));
//     	console.log("Calculate B");
    }
  	else if(b > 0 && c > 0){
      	a = Math.sqrt(c*c - b*b);
      	$('.pitch input[name="flat"]').val(a.toFixed(2));
//     	console.log("Calculate A");
    }
}